<template>
  <v-container fluid pa-0>
    <!-- Header and Search -->
    <v-layout
      row
      wrap
      align-center
      justify-space-around
      style="min-height: 180px"
      :class="deviceClasses.lay1"
    >
      <v-flex xs11 sm11 md5 :class="deviceClasses.icon">
        <v-icon size="35px" class="v-middle">person_add</v-icon>
        <span class="title white--text ml-3 v-middle">{{
          item.edit ? $t("edit_record") : $t("new_record")
        }}</span>
      </v-flex>
      <v-flex xs11 md5 class="mb-4 text-xs-right">
        <v-btn color="secondary" @click="$router.go(-1)">
          <span class="pb-1 mt-1">{{ $t("return") }}</span>
        </v-btn>
      </v-flex>
    </v-layout>
    <!-- end of header -->
    <!-- Stepper forms -->
    <v-layout row wrap justify-center style="margin-top: -53px">
      <v-flex xs12 md11>
        <v-card>
          <v-card-title class="body-2 grey lighten-3"
            >User Details</v-card-title
          >
          <v-container fluid grid-list-xs>
            <v-form class="layout row wrap px-3 pt-4">
              <v-flex xs11 md5>
                <v-autocomplete
                  outline
                  autocomplete
                  :items="branches"
                  placeholder=" "
                  item-value="id"
                  item-text="name"
                  :label="$t('branch')"
                  data-vv-name="branch"
                  v-model="item.branch_id"
                  v-validate="'required'"
                  :data-vv-as="$t('branch')"
                  :error-messages="errors.collect('branch')"
                />
                <v-text-field
                  outline
                  placeholder=" "
                  :label="$t('name')"
                  v-model="item.name"
                  data-vv-name="name"
                  @input="correct = true"
                  v-validate="'required'"
                  :data-vv-as="$t('name')"
                  :error-messages="errors.collect('name')"
                />
                <v-text-field
                  outline
                  type="email"
                  placeholder=" "
                  :label="$t('email')"
                  v-model="item.email"
                  data-vv-name="email"
                  @input="correct = true"
                  :data-vv-as="$t('email')"
                  v-validate="'required|email'"
                  :error-messages="errors.collect('email')"
                />
                <v-text-field
                  outline
                  placeholder=" "
                  type="password"
                  @input="correct = true"
                  v-validate="'required'"
                  data-vv-name="password"
                  v-model="item.password"
                  :data-vv-as="$t('password')"
                  :error-messages="errors.collect('password')"
                  :label="item.edit ? $t('new_password') : $t('password')"
                />

                <v-autocomplete
                  multiple
                  outline
                  autocomplete
                  :items="roles"
                  return-object
                  placeholder=" "
                  item-value="id"
                  item-text="name"
                  :label="$t('role')"
                  data-vv-name="role"
                  v-model="item.roles"
                  v-validate="'required'"
                  :data-vv-as="$t('role')"
                  :error-messages="errors.collect('role')"
                />
              </v-flex>
              <v-flex xs11>
                <v-btn
                  color="primary mx-0"
                  :loading="loading"
                  @click="addData"
                  >{{ $t("save") }}</v-btn
                >
              </v-flex>
            </v-form>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      roles: [],
      branches: [],
      loading: false,
    };
  },
  computed: {
    deviceClasses() {
      if (this.$vuetify.breakpoint.mdAndUp)
        return {
          lay1: "primary",
          icon: "mb-5 align-center",
        };
      return {
        lay1: "primary",
        icon: "mb-5 align-center",
      };
    },
  },
  methods: {
    reset() {
      this.item = {
        active: true,
      };
    },
    getRoles() {
      this.axios.get("users/create").then((res) => {
        this.roles = Object.values(res.data);
      });
      this.axios.get("branches").then((res) => {
        this.branches = Object.values(res.data);
      });
    },
    initData() {
      let id = this.$store.state.route.params.id;
      this.item = {
        id: null,
        name: null,
        email: null,
        edit: false,
        roles: [],
        password: null,
      };
      if (id) {
        this.axios
          .get("users/" + id)
          .then((res) => {
            this.item = { edit: true, ...res.data, password: "default" };
          })
          .catch((err) => {});
      }
      this.getRoles();
      this.$validator.reset();
    },

    addData() {
      this.loading = true;
      this.$validator.validateAll().then((succeed) => {
        if (succeed) {
          let role_ids = [];
          this.item.roles.forEach((x) => role_ids.push(x.id));
          this.item.roles = role_ids;
          this.axios
            .post("users", this.item)
            .then((resp) => {
              this.loading = false;
              this.reset()
              this.$store.commit("showSnackbar", {
                stateType: "success",
                text: this.$t("save_succeed"),
                show: true,
              });
              this.$router.go(-1);
            })
            .catch((error) => {
              this.loading = false;
              console.log(error, "\n error");
              this.$store.commit("showSnackbar", {
                stateType: "error",
                text: error.msg,
                show: true,
              });
            });
        } else {
          this.loading = false;
          this.$store.commit("showSnackbar", {
            text: this.$t("wrong_input"),
            stateType: "error",
            show: true,
          });
        }
      });
    },
  },
  created() {
    this.reset()
    this.initData();
  },
};
</script>